import { useTranslation } from 'react-i18next';
import { routes } from 'routes/routes';
import { Link, Text } from 'ui';

const termsUrl = String(import.meta.env.VITE_APP_TERMS_URL);

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <Text>
      {import.meta.env.VITE_APP_LANDING_SUMMARY}{' '}
      <a href={termsUrl} rel="noopener noreferrer" target="_blank">
        {t('Terms')}
      </a>{' '}
      &amp;{' '}
      <Link rel="noopener noreferrer" target="_blank" to={routes.privacyPolicy}>
        Privacy Policy
      </Link>
    </Text>
  );
};
